<template>
	<div class="loginComponent">
		<p>Логин</p>
		<input type='text' id='login' placeholder='Введите почту или имя пользователя' v-model='login'/>
		<p>Пароль</p>
		<div class="passwordInput">
			<input type='password' id='password' placeholder='Введите пароль' v-model='password'/>
			<Transition name='fade'><img src='../assets/icons/openEye.svg' width='26px' @click='showPasswordClick' v-if='showPassword' /></Transition>
			<Transition name='fade'><img src='../assets/icons/closeEye.svg' width='28px' @click='showPasswordClick' v-if='!showPassword' /></Transition>
		</div>
		<button class='authButton' @click='signInButton'>Войти</button>
		<a href='#' style='text-align: center; color: #333333B2; text-decoration: underline;'>Политика конфиденциальности и правила сервиса</a>
		<Transition name='fade'>
			<ErrorBlock v-if='isError'/>
		</Transition>
	</div>
	
</template>

<script>
import axios from 'axios'
import { useToast } from 'vue-toastification'
import ErrorBlock from './ErrorBlock.vue'


export default {
  name: 'LoginComponent',
	data() {
		return {
			login: "",
			password: "",
			isError: false,
			showPassword: true
		}
	},
	setup() {
		const toast = useToast()
		return {toast}
	},
	components: {
		ErrorBlock
	},
  methods: {
		showPasswordClick() {
			let input = document.querySelector('.passwordInput input')
			if (this.showPassword) {
				input.type = "text"
				this.showPassword = false
			}
			else {
				input.type = "password"
				this.showPassword = true
			}
		},
		showError(element) {
			let el = document.querySelector(element)
			let posY = el.offsetTop;
			setTimeout(() => {
				let el1 = document.querySelectorAll('.errorBlock')
				for (let e of el1) e.style.top = posY+"px"
			},10)
			setTimeout(() => {
				this.isError = false
			},4000)
		},
		signInButton() {
			let inps = document.querySelectorAll('.loginComponent input')
			let newInps = []
			for (let i of inps) if (i.value.length == 0) newInps.push(i)
			newInps.reverse()
			if (newInps.length > 0) {
				this.isError = true
				for (let i of newInps) {
					console.log(i)
					if (i.id == "password") this.showError('.passwordInput')
					else this.showError('#' + i.id)
				}
			}
			else {
				axios.post(`https://${process.env.VUE_APP_SERVERHOST}/api/auth/login`, {
					login: this.login,
					password: this.password
				})
				.then(res => {
					this.$store.commit('setUserData', res.data.result)
					console.log(res)
					axios.get(`https://${process.env.VUE_APP_SERVERHOST}/api/public/cities`)
					.then(res => {
						let user = this.$store.getters.getUserData
						console.log(user)
						const findCity = res.data.result.find(item => item._id === user.cityId)
						this.$store.commit('setCity',findCity.name)
						window.location.reload()
					})
				})
				.catch(err => {
					this.toast.error(err.response.data.message)
				})
			}
		},	
	}
}
</script>
<style scoped>
.loginComponent {
	display: flex;
	flex-direction: column;
	gap:10px;
}
.authButton {
	background-color: #FF8989;
	display: flex;
	align-items: center;
	justify-content: center;
	outline: none;
	border: 1px solid #FF8989;
	padding: 13px;
	color: white;
	font-weight: 600;
	border-radius: 10px;
	cursor: pointer;
}
input {
	outline: none;
	background-color: #FFFFFF;
	border-radius: 10px;
	border: 1px solid #D8DADC;
	padding: 15px;
	width: 100%;
}
p {
	color: #333333;
	font-size: 14px;
}
.passwordInput {
	position: relative;
}
.passwordInput img {
	position: absolute;
	right:15px;
	top:50%;
	transform: translateY(-50%);
	cursor: pointer;
}
</style>
